import React from 'react';
import styles from './TableHeader.module.scss';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { MdFileDownload } from 'react-icons/md';
import { Outline, TextLink } from '@otcmarketsgroup/otcm-ui';
import PropTypes from 'prop-types';
import { Tooltip } from 'devextreme-react/tooltip';
import classNames from 'classnames';

const loadIndicatorAttributes = {
  style: 'margin-top:2px;height:20px;width:20px'
};

class TableHeader extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      // default hide
      downloadIconTooltip: false,
      copyToClipboardTooltip: false,
      emailTooltip: false,
      columnChooserTooltip: false
    };

    this.toggleColumnChooserTooltip = this.toggleColumnChooserTooltip.bind(this);
    this.toggleCopyToClipBoardTooltip = this.toggleCopyToClipBoardTooltip.bind(this);
    this.toggleEmailClipBoardTooltip = this.toggleEmailClipBoardTooltip.bind(this);
    this.hideDownloadIconTooltip = this.hideDownloadIconTooltip.bind(this);
    this.showDownloadIconTooltip = this.showDownloadIconTooltip.bind(this);
    this.download = this.download.bind(this);

  }
  toggleColumnChooserTooltip () {
    this.setState({
      columnChooserTooltip: !this.state.columnChooserTooltip
    });
  }

  showDownloadIconTooltip () {
    this.setState({
      downloadIconTooltip: true
    });
  }

  hideDownloadIconTooltip () {
    this.setState({
      downloadIconTooltip: false
    });
  }

  download () {
    this.setState({
      downloadIconTooltip: false
    },
    this.props.download);
  }

  toggleCopyToClipBoardTooltip () {
    this.setState({
      copyToClipboardTooltip: !this.state.copyToClipboardTooltip
    });
  }

  toggleEmailClipBoardTooltip () {
    this.setState({
      emailTooltip: !this.state.emailTooltip
    });
  }

  render () {
    const downloadIconId = this.props.downloadIconId || 'downloadIcon';
    const downloadToolTipTarget = '#' + downloadIconId;

    const columnChooserIconId = this.props.columnChooserIconId || 'columnChooserIcon';
    const columnChooserToolTipTarget = '#' + columnChooserIconId;

    const copyToClipboardIconId = this.props.copyToClipboardIconId || 'copyIcon';
    const copyToClipboardIconToolTipTarget = '#' + copyToClipboardIconId;

    const emailIconId = this.props.emailIconId || 'emailIcon';
    const emailIconIdTarget = '#' + emailIconId;

    const tableHeaderMargin = this.props.tableHeaderMargin || false;
    const tableHeaderStyle = tableHeaderMargin ? styles.tableHeaderMargin : '';

    return (
      <div className={tableHeaderStyle}>
        <Outline
          mode='headingSmall'
          spacing='none'
          className={this.props.className}
          bottomBorderOnly={this.props.bottomBorderOnly}
          topBorderOnly={this.props.topBorderOnly}
          content={

            <div id={'gridControls'} className={styles.controls}>
              {this.props.openEmail && <div>
                <span>
                  <i id={emailIconId} className={classNames('dx-icon-email')}
                    onClick={this.props.openEmail}
                    onMouseEnter={this.toggleEmailClipBoardTooltip}
                    onMouseLeave={this.toggleEmailClipBoardTooltip}
                  />
                </span>
                <Tooltip
                  target={emailIconIdTarget}
                  position='left'
                  visible={this.state.emailTooltip}
                  hideOnOutsideClick={false}
                > Open Email</Tooltip>
              </div> }
              {this.props.onCopyToClipboardClick && <div>
                <span>
                  <i id={copyToClipboardIconId} className={classNames('dx-icon-copy')}
                    onClick={this.props.onCopyToClipboardClick}
                    onMouseEnter={this.toggleCopyToClipBoardTooltip}
                    onMouseLeave={this.toggleCopyToClipBoardTooltip}
                  />
                </span>
                <Tooltip
                  target={copyToClipboardIconToolTipTarget}
                  position='left'
                  visible={this.state.copyToClipboardTooltip}
                  hideOnOutsideClick={false}
                > Copy To Clipboard</Tooltip>
              </div> }

              {this.props.onColumnChooserClick && <div>
                <span>
                  <i id={columnChooserIconId} className={classNames('dx-icon-columnchooser')}
                    onClick={this.props.onColumnChooserClick}
                    onMouseEnter={this.toggleColumnChooserTooltip}
                    onMouseLeave={this.toggleColumnChooserTooltip}
                  />
                </span>
                <Tooltip
                  target={columnChooserToolTipTarget}
                  position='left'
                  visible={this.state.columnChooserTooltip}
                  hideOnOutsideClick={false}
                > Open Column Chooser</Tooltip>
              </div> }

              {this.props.textLink && <div>
                <TextLink className={this.props.textLinkClassName} text={this.props.textLink} onClick={this.props.onTextLinkClick} />
              </div> }

              {this.props.download && !this.props.showDownloadIndicator && <div>
                <span>
                  <MdFileDownload id={downloadIconId} className={styles.downloadIcon}
                    onMouseEnter={this.showDownloadIconTooltip}
                    onMouseLeave={this.hideDownloadIconTooltip}
                    onClick={this.download} />
                </span>
                <Tooltip
                  target={downloadToolTipTarget}
                  position='left'
                  visible={this.state.downloadIconTooltip}
                  hideOnOutsideClick={false}
                > Download Data</Tooltip>
              </div>}
              {this.props.showDownloadIndicator && <div><span>
                <LoadIndicator elementAttr={loadIndicatorAttributes} visible={this.props.showDownloadIndicator} />
              </span></div>}
            </div>

          }
        >
          {!this.props.headerUpperCase && this.props.header}
          {this.props.headerUpperCase && this.props.header.toUpperCase()}
        </Outline>

      </div>
    );
  }
}

export default TableHeader;

TableHeader.propTypes = {
  header: PropTypes.string,
  className: PropTypes.any,
  textLink: PropTypes.string,
  onTextLinkClick: PropTypes.func,
  textLinkClassName: PropTypes.any,
  download: PropTypes.func,
  downloadIconId: PropTypes.string,
  showDownloadIndicator: PropTypes.bool,
  columnChooserIconId: PropTypes.string,
  copyToClipboardIconId: PropTypes.string,
  emailIconId: PropTypes.string,
  onColumnChooserClick: PropTypes.func,
  onCopyToClipboardClick: PropTypes.func,
  openEmail: PropTypes.func,
  tableHeaderMargin: PropTypes.bool,
  headerUpperCase: PropTypes.bool,
  bottomBorderOnly: PropTypes.bool,
  topBorderOnly: PropTypes.bool
};

TableHeader.defaultProps = {
  header: 'Table data',
  tableHeaderMargin: true,
  headerUpperCase: true,
  bottomBorderOnly: false,
  topBorderOnly: false
};
